module.exports = __webpack_public_path__ + "static/media/safe_xplore_TM_white_no_border_1.8e3ed452.svg";